import { render, staticRenderFns } from "./registroformulario.vue?vue&type=template&id=fad5e018&"
import script from "./registroformulario.vue?vue&type=script&lang=js&"
export * from "./registroformulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports